import axios from "axios";
import pkg from "../../package.json";

import { API_URL, HTTP_ERRORS } from "../constants/api";

export interface fetchCreatorParams {}

export const refreshToken = (successCallback?: () => void) => {
  const refresh_token = localStorage.getItem("@refresh_token");
  const uri = "oauth2/web/token";
  axios
    .post(uri, { grant_type: "refresh_token", refresh_token })
    .then(({ data }: any) => {
      const { refresh_token, access_token } = data;
      localStorage.setItem("@refresh_token", refresh_token);
      localStorage.setItem("@access_token", access_token);

      axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
      if (successCallback) successCallback();
    })
    .catch((err) => {
      if (!window.location.pathname.includes("/logout")) {
        window.location.replace("/logout");
        console.error(err);
      }
    });
};

export const updateRoleOnRefresh = (successCallback?: () => void) => {
  const access_token = localStorage["@access_token"];
  const uri = "oauth2/token/refresh?authorization=$TOKEN";
  axios
    .get(uri.replace("$TOKEN", access_token))
    .then(({ data }: any) => {
      const { refresh_token, access_token } = data;
      localStorage.setItem("@refresh_token", refresh_token);
      localStorage.setItem("@access_token", access_token);

      axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
      successCallback?.();
    })
    .catch((err) => {
      if (!window.location.pathname.includes("/logout")) {
        window.location.replace("/logout");
        console.error(err);
      }
    });
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === HTTP_ERRORS.Unauthorized) {
        refreshToken();
      }

      if (status === HTTP_ERRORS.Not_Found) {
        return Promise.resolve(null);
      }
    } else {
      console.error("Error sin respuesta del servidor:", error);
    }

    return Promise.reject(error);
  }
);

export default class fetchCreator implements fetchCreatorParams {
  constructor() {
    axios.defaults.baseURL = API_URL;

    const access_token = localStorage.getItem("@access_token");

    axios.defaults.headers.common = {
      ...axios.defaults.headers.common,
      Authorization: `Bearer ${access_token}`,
      "app-version": `${pkg.name}-${pkg.version}`,
    };
  }

  async get(module: string | null = null, params = {}) {
    if (module === null) {
      return;
    }

    try {
      return await axios.get(`${module}`, {
        params,
      });
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  async post(module: string | null = null, params = {}, config = {}) {
    if (module === null) {
      return;
    }

    try {
      return await axios.post(`${module}`, params, config);
    } catch (e) {
      console.error({ e });
      throw e;
    }
  }

  async patch(module: string | null = null, params = {}) {
    if (module === null) {
      return;
    }

    try {
      return await axios.patch(`${module}`, params, {});
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  async put(module: string | null = null, params = {}) {
    if (module === null) {
      return;
    }

    try {
      return await axios.put(`${module}`, params, {});
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  async delete(module: string | null = null) {
    if (module === null) {
      return;
    }

    try {
      return await axios.delete(`${module}`, {});
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
